import { DynamicType } from '@meitu/saas-editor-core/es/version-types';

export interface IDynamicBgLayerProps {
    backgroundColor: string;
    shaderUrl: string;
}

export const createShader = (gl: WebGLRenderingContext, type: number, source: string) => {
    const shader = gl.createShader(type);
    if (shader) {
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            console.error('着色器编译错误: ' + gl.getShaderInfoLog(shader));
            gl.deleteShader(shader);
            return null;
        }
        return shader;
    }

    return null;
};
export const createProgram = (gl: WebGLRenderingContext, vertexShaderSource: string, fragmentShaderSource: string) => {
    const program = gl.createProgram();
    const vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexShaderSource);
    const fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, fragmentShaderSource);
    if (program && vertexShader && fragmentShader) {
        gl.attachShader(program, vertexShader);
        gl.attachShader(program, fragmentShader);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            console.error('Unable to initialize the shader program: ' + gl.getProgramInfoLog(program));
            return null;
        }
        return program;
    }
};

export const getShaderSource = async (shaderUrl: string) => {
    const res = await fetch(shaderUrl);
    return res.json();
};

export const getShaderList = () => {
    return [
        {
            name: 'Animation1',
            url: '',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.CSS,
        },
        {
            name: 'Animate2',
            url: '',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.CSS,
        },
        {
            name: 'Animate3',
            url: '',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.CSS,
        },
        {
            name: 'Animate4',
            url: '',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.CSS,
        },
        {
            name: 'Dazzle',
            url: 'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/bgShader/Dazzle.json',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.Shader,
        },
        {
            name: 'Flower',
            url: 'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/bgShader/Flower.json',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.Shader,
        },
        {
            name: 'Flower2',
            url: 'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/bgShader/Flower2.json',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.Shader,
        },
        {
            name: 'Gradient',
            url: 'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/bgShader/Gradient.json',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.Shader,
        },
        {
            name: 'GridLight',
            url: 'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/bgShader/GridLight.json',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.Shader,
        },
        {
            name: 'Halo',
            url: 'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/bgShader/Halo.json',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.Shader,
        },
        {
            name: 'Neuro Noise',
            url: 'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/bgShader/Neuro Noise.json',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.Shader,
        },
        {
            name: 'Pastel',
            url: 'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/bgShader/Pastel.json',
            screenshotUrl: 'https://xiuxiu-pro.meitudata.com/posters/dbd5b8a67859f5f312b0d8e0206593a3.jpg',
            type: DynamicType.Shader,
        },
    ];
};
